module.exports = __webpack_public_path__ + "static/media/category2.8ce016b4.jpg";